import { render, staticRenderFns } from "./CellRendererVesselName.vue?vue&type=template&id=6ce4b14c&scoped=true"
import script from "./CellRendererVesselName.vue?vue&type=script&lang=js"
export * from "./CellRendererVesselName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce4b14c",
  null
  
)

export default component.exports